<template>
  <div class="text-search-row clearfix" :class="[theme === 1 ? 'text-search-row' : 'text-search-row-2', isAma ? 'ama-background' : '']">
    <div class="container">

      <div class="input-group mb-3">
        <input class="form-control text-left float-left" :class="[theme === 1 ? 'input-border' : 'input-border-2']"
          type="text" name="search" :placeholder="$t('skuAndDescr')" id="searchId" v-on:keyup.enter="searchByText"
          v-model="textToSearch" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" v-on:click="searchByText">
            <font-awesome-icon :icon="['fas', 'search']" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "SearchBar",
  data() {
    return {
      textToSearch: "",
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.config.theme,
      currentCategory: (state) => {
        return state.detail.currentCategory;
      },
      searchJewel: (state) => state.list.searchJewel,
      currentJewelSelection: (state) => state.detail.currentJewelSelection,
      isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
      isAma: (state) => state.config.isAma,
    }),
    productType: function () {
      let productType = 'JEWELLERY';
      if (this.isGioielleriaItalianaB2B)
        productType = null;
      else if (this.isAma)
        productType = 'AMA_JEWELLERY';
      return productType;
    }
  },
  watch: {
    searchJewel: {
      handler: function (newValue, oldValue) {
        this.textToSearch = this.searchJewel.text;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("list", ["search"]),
    ...mapMutations("list", ["setJewelSearch", "setCurrentCategory"]),
    ...mapMutations("detail", ["setQuantity", "setPreselectedJewel"]),

    //this function call an API that search by sku and description
    searchByText() {
      if (!this.textToSearch && this.searchJewel.text == null) return;

      // let txt = this.textToSearch;

      // setTimeout(() => {
      // if (txt === this.textToSearch) {
      this.setJewelSearch({
        label: "goldColor",
        value: null,
      });

      this.setJewelSearch({
        label: "goldColorId",
        value: null,
      });
      this.setJewelSearch({
        label: "stoneColor",
        value: null,
      });
      this.setJewelSearch({
        label: "category",
        value: null,
      });
      this.setJewelSearch({
        label: "subCategory",
        value: null,
      });
      this.setJewelSearch({
        label: "minPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "maxPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "text",
        value: this.textToSearch != "" ? this.textToSearch : null,
      });
      this.setJewelSearch({
        label: "sku",
        value: this.textToSearch != "" ? this.textToSearch : null,
      });
      this.setJewelSearch({
        label: "productType",
        value: this.productType,
      });
      this.setJewelSearch({
        label: "minAvailability",
        value: 0,
      });
      // this.search(this.searchJewel);
      // this.scrollTo(0);

      this.$router.replace({
        name: "list.sublist",
        params: {
          productType: this.productType,
          typeId: null,
        },
      }).catch(() => { });

      this.searchItems();
      // }
      // }, 500);
    },

    searchItems() {
      this.setPreselectedJewel({});
      this.setQuantity(1);
      this.setCurrentCategory({ productType: this.productType });
      if (
        this.$route.name == "list.sublist"
      ) {
        this.search(this.searchJewel);
      } else {
        this.$router.push({
          name: "list.sublist",
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text-search-row {
  background-color: var(--primary-color-1);
  padding: 30px;
  text-align: center;
  &.ama-background {
    background-color: var(--ama-gray);
  }
}

.text-search-row-2 {
  background-color: transparent;
  padding: 30px;
  text-align: center;
}

.input-border {
  border: none;
  border: 1px solid var(--primary-color-1);
}

.input-border::placeholder {
  color: var(--primary-color-1);
}

.input-border-2 {
  border: none;
  width: 100%;
  border: 1px solid var(--secondary-color-1);
}

.input-border::placeholder {
  color: var(--primary-color-1);
}
</style>
